import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { globalSettingsRoutes } from './global-settings-routes';

@NgModule({
  imports: [RouterModule.forChild(globalSettingsRoutes)],
  exports: [ RouterModule ]
})

export class GlobalSettingsRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/global-settings-routing.module.ts